<template>
  <popup
    :opened="dataToShow"
    @close="close"
  >
    <div class="m-5 lg:m-15 2xl:m-20 flex flex-col items-center">
      <h3>{{ subscriptionToEdit.name }}</h3>
      <div class="grid grid-cols-4 items-center gap-5 mt-15">
        <p class="col-span-2">
          Début de l'abonnement :
        </p><p class="col-span-2">
          {{ dateDebut }}
        </p>
        <p class="col-span-2">
          Fin de l'abonnement :
        </p><p class="col-span-2">
          {{ (subscriptionToEdit.expiry_date) ? (plans.monthly_with_commitment.includes(subscription.stripe_plan)) ? ("0"+new Date(subscriptionToEdit.expiry_date).getDate()).slice(-2)+'/'+("0"+new Date(subscriptionToEdit.expiry_date).getMonth()).slice(-2)+'/'+(new Date(subscriptionToEdit.expiry_date).getFullYear()+1) : new Date(subscriptionToEdit.expiry_date).toLocaleDateString("fr") : "Aucun abonnement" }}
        </p>
        <p class="col-span-2">
          Type d'abonnement :
        </p><p class="col-span-2">
          {{
            (plans.yearly.includes(subscription.stripe_plan)) ? "Annuel" :
            ((plans.monthly_with_commitment.includes(subscription.stripe_plan)) ? "Mensuel avec engagement" :
              ((plans.monthly_without_commitment.includes(subscription.stripe_plan)) ? "Mensuel sans engagement" :
                ((subscriptionToEdit.days_before_trial_end > 0) ? "Période d'essai" : "")))

          }}
        </p>
        <p class="col-span-2">
          Nombre de carnets total :
        </p><p class="col-span-2">
          {{ totalNeopass }}
        </p>
        <p class="col-span-2">
          Nombre de carnets utilisés :
        </p><p class="col-span-2">
          {{ subscriptionToEdit.neopass_count }}
        </p>
        <p class="col-span-2">
          Nombre de carnets restants :
        </p><p class="col-span-2">
          {{ (parseInt(totalNeopass) - parseInt(subscriptionToEdit.neopass_count)) }}
        </p>
        <div
          class="col-start-1 col-span-full flex justify-center"
        >
          <action-button
            class="mt-10"
            border-color="border-transparent"
            text-color="text-gray-900"
            bg-color="bg-indigo-300"
            bg-color-square="bg-indigo-100"
            icon-color="text-indigo-600"
            libelle="Ajouter un carnet"
            :right="true"
            :responsive="true"
            icon="plus"
            @clickAction="displayAddNeopassForm(true)"
          />
        </div>

        <input-text
          v-show="isAddNeopassFormDisplayed"
          name="NombreNeopassSouscris"
          libelle="Nombre de carnet à ajouter"
          type="number"
          :value="nbNeopassSubscribed"
          @input="
            newValue => {
              nbNeopassSubscribed = newValue;
            }
          "
          class="lg:col-span-2"
          :error="true"
          :min="0"
        />
        <div class="col-span-1 flex justify-center self-end">
          <action-button
            v-show="isAddNeopassFormDisplayed"
            border-color="border-transparent"
            text-color="text-gray-900"
            bg-color="bg-teal-300"
            bg-color-square="bg-teal-300"
            icon-color="text-teal-600"
            libelle="Valider"
            :right="true"
            :responsive="true"
            icon="checkmark"
            @clickAction="addNeopass"
          />
        </div>
        <div
          v-show="isAddNeopassFormDisplayed"
          class="text-pink-600 col-span-full flex space-x-2 items-center"
        >
          <icon name="alert-circle" />
          <p>La fonctionnalité d'ajout de carnet de parcours n'est pas encore disponible</p>
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from './../Popup.vue';
import ActionButton from './../ActionButton.vue';
import InputText from './../Inputs/InputText.vue';
import Icon from './../Icon.vue';

export default {
  components:{
    Popup,
    ActionButton,
    Icon,
    InputText,
  },

  props:{
    subscriptionToEdit: {
      type: Object,
      required:false,
      default: () => {return {};},
    },
    dataToShow:{
      type:Boolean,
      required:false,
      default:false,
    }
  },

  data(){
    return {
      plans: {
        yearly: [process.env.MIX_OLD_PRICE_PLAN_YEARLY, process.env.MIX_PRICE_PLAN_YEARLY],
        monthly_with_commitment: [process.env.MIX_OLD_PRICE_PLAN_MONTHLY_WITH_COMMITMENT, process.env.MIX_PRICE_PLAN_MONTHLY_WITH_COMMITMENT],
        monthly_without_commitment:[process.env.MIX_OLD_PRICE_PLAN_MONTHLY_WITHOUT_COMMITMENT, process.env.MIX_PRICE_PLAN_MONTHLY_WITHOUT_COMMITMENT]
      },
      nbNeopassSubscribed:0,
      isAddNeopassFormDisplayed:false,
    };
  },

  methods:{
    close(){
      this.displayAddNeopassForm(false);
      this.$emit('close');
    },

    displayAddNeopassForm(state){
      this.nbNeopassSubscribed= 0;
      this.isAddNeopassFormDisplayed = state;
    },

    addNeopass(){
      alert('La fonctionnalité d\'ajout de carnet de parcours n\'est pas encore disponible');
    }
  },

  computed:{
    subscription(){
      return ((((this.subscriptionToEdit || {}).payer || [])[0] || {}).subscriptions || [])[0] || {};
    },

    totalNeopass(){
      return (this.subscriptionToEdit.expiry_date != null && new Date(this.subscriptionToEdit.expiry_date) >= new Date()) ? this.subscription.quantity : (this.subscriptionToEdit.days_before_trial_end > 0) ? 1 : 0;
    },

    dateDebut(){
      return new Date(
        (this.subscriptionToEdit.expiry_date != null) ? this.subscription.created_at : this.subscriptionToEdit.created_at
      ).toLocaleDateString('fr');

    }
  }
};
</script>
